"use client";

import { useEffect, useRef, useState } from "react";

import * as motion from "motion/react-client";

import { Icon } from "@iconify/react";
import AppLogo from "./AppLogo";
import ButtonLink from "@/src/shared/button/ButtonLink";
import ThemeSwitcher from "../../components/ThemeSwitcher";
import InputField from "./form/InputField";
import Search from "@/components/Search";
import UserWidget from "@/components/UserWidget";
import { logout } from "../actions/auth";
import AppDownloadButton from "./button/AppDownloadButton";
import Link from "next/link";
import Logger from "../exceptions/Logger";
import PrimaryButton from "./button/PrimaryButton";
import AppIcon from "./Icon";
import UserDropdown from "@/components/UserDropdown";
import NotificationDropdown from "./header/NotificationDropdown";
import { ThemeToggleButton } from "@/components/common/ThemeToggleButton";


interface NavigationInterface {
    type?: "guest" | "user";
    handleLogout?: (evt:any) => void,
}

export default function Navigation(props: NavigationInterface) {
    const { type, handleLogout } = props;

    const [openMobileNav, setOpenMobileNav] = useState(false);

    // useEffect(() => {
    //     if (openMobileNav) {
    //         document.body.classList.add("overflow-hidden");
    //         document.documentElement.classList.add("overflow-hidden");
    //     } else {
    //         document.body.classList.remove("overflow-hidden");
    //         document.documentElement.classList.remove("overflow-hidden");
    //     }

    //     return () => {
    //         document.body.classList.remove("overflow-hidden");
    //         document.documentElement.classList.remove("overflow-hidden");
    //     }
    // }, []);

    return (
        <>
            <div 
                className={`w-full flex h-17.5 sticky z-50 top-0 group bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800 justify-between 
                    px-5 [&.guest]:lg:px-37.5 items-center gap-2.5 ${type ?? "guest"}`}
            >
                <div className="flex gap-5 items-center self-stretch">
                    <div className="self-stretch flex-col justify-center items-center hidden group-[.guest]:inline-flex">
                        {/* <div className="text-sky-500 text-3xl font-black">X</div> */}
                        <a href="/">
                            <AppLogo />
                        </a>
                    </div>
                    
                    {/* Admin Pannel Nav Button */}
                    <div className="p-0.5 justify-start items-center gap-2.5 hidden group-[.user]:md:flex">
                        <button type="button" className="relative">
                            <Icon icon="gg:menu-right" className="text-slate-500 dark:text-slate-300 w-6 h-6" />
                        </button>
                    </div>

                    {/* <div className="pl-8">
                        <Search />
                        </div> */}
                </div>



                <div className="relative flex-1 hidden group-[.guest]:flex justify-end self-stretch items-center">
                    {/* Public Mobile Nav Button */}
                    <div className="visible md:hidden px-5">
                        <button type="button" className="relative" onClick={() => setOpenMobileNav(true)}>
                            <Icon icon="gg:menu-right" className="text-slate-500 dark:text-slate-300 size-6" />
                            <span className="sr-only">Open Menu</span>
                        </button>
                    </div>

                    <div 
                        className={`group mmenu ${openMobileNav? "open" : "close"}`}
                    >
                        {/* Backdrop */}
                        <motion.div 
                            className="w-full h-full hidden group-[.open]:block bg-black/50" 
                            initial={{opacity: 0}}
                            animate={{opacity: 1}}
                            exit={{opacity: 0}}
                            transition={{duration: 0.3, ease: "easeInOut"}}
                            onClick={() => setOpenMobileNav(false)}
                        ></motion.div>

                        <div className={`mmenu-inner`}>
                            <div className="h-17.5 hidden group-[.open]:flex justify-between items-center border-b border-gray-100 dark:border-gray-700 px-5">
                                <a href="/">
                                    <AppLogo />
                                </a>

                                <PrimaryButton 
                                    scheme="dark" 
                                    className="transparent"
                                    onClick={() => setOpenMobileNav(false)}
                                >
                                    <AppIcon icon="cancel" className="text-2xl font-bold" />
                                </PrimaryButton>
                            </div>

                            <div 
                                className="h-full relative hidden group-[.open]:flex flex-col lg:flex lg:flex-row gap-x-20 lg:gap-x-40 justify-between lg:justify-start 
                                    lg:items-center"
                            >
                                <div className="nav-link text-gray-500">
                                    <ul className="flex flex-col lg:flex-row lg:gap-x-1">
                                        <li><a href="/">Home</a></li>
                                        <li><a href="/about-us">About Us</a></li>
                                        <li><a href="/contact-us">Contact Us</a></li>
                                    </ul>
                                </div>
                                
                                <div className="flex gap-x-2.5 px-5 lg:px-0 py-5 lg:py-0">
                                    <ButtonLink href="/" className="w-full">
                                        Download
                                    </ButtonLink>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="justify-start items-center gap-3 hidden group-[.user]:flex">
                    {/* <ThemeSwitcher /> */}
                    <ThemeToggleButton />

                    {/* <div className="p-1.25 justify-start items-center gap-2.5 flex">
                        <button className="relative">
                            <Icon icon="solar:bell-broken" className="w-6 h-6 text-slate-500 dark:text-slate-300" />
                        </button>
                    </div> */}

                    <NotificationDropdown />

                    {/* <UserWidget 
                        handleLogout={handleLogout}
                    /> */}
                    <UserDropdown 
                        handleLogout={handleLogout}
                    />
                </div>
            </div>
        </>
    )
}